import BreadCrumb from 'components/BreadCrumb'
import LoadingContainer from 'components/LoadingContainer'
import { Typography } from 'new-components/atoms'
import { ArrowRightCircle } from 'lucide-react'
import { useMemo } from 'react'
import { useHistory } from 'react-router'
import { useGetActiveBrands } from '@cannect/services/resources/brands'

function Brands() {
  const history = useHistory()
  const { data: activeBrandsData, isLoading } = useGetActiveBrands()

  const brandsList = useMemo(() => {
    const items = activeBrandsData?.brands || []
    return items.map((brand: any) => {
      const logoPath = brand?.brandInfos?.logo || brand?.brandInfos?.alternativeLogo || undefined
      return {
        label: brand?.name,
        path: logoPath,
        onClick: () =>
          history.push({
            pathname: `/produtos-marca/1`,
            search: `?brand_id=${brand.id}`,
            state: {
              brand_name: brand?.name,
              logo: logoPath,
              banner_bg_url: brand?.brandInfos?.banner_bg_url || undefined,
              banner_title: brand?.brandInfos?.banner_title || undefined,
              banner_subtitle: brand?.brandInfos?.banner_subtitle || undefined,
              banner_title_color: brand?.brandInfos?.banner_title_color || undefined,
              banner_subtitle_color: brand?.brandInfos?.banner_subtitle_color || undefined,
              description_cols: brand?.brandInfos?.description_cols || undefined
            }
          })
      }
    }) as { label?: string; path?: string; onClick: () => void }[]
  }, [activeBrandsData, history])

  return (
    <div className="w-ful mx-auto px-4 py-8 sm:px-6">
      <BreadCrumb paths={[{ label: 'Marcas Parceiras', link: '/marcas' }]} />

      {/* Header Section */}
      <div className="mb-12 text-start">
        <Typography.Heading type="headingFour" weight="medium" className="text-xl text-gray-900 sm:text-5xl">
          <span className="text-neutral-800">Parceiros Cannect</span>
        </Typography.Heading>
        <Typography.Text className="w-full text-lg text-neutral-800">
          Conheça as marcas parceiras que fazem parte do nosso ecossistema de cuidados com cannabis medicinal
        </Typography.Text>
      </div>

      {/* Brands Grid - 4 colunas como na home */}
      {isLoading ? (
        <LoadingContainer loading />
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {brandsList?.map((brand: any, index: number) => (
            <div
              key={`${brand?.label || 'brand'}-${index}`}
              className="flex h-fit w-full flex-shrink-0 flex-col justify-between overflow-hidden rounded-md bg-white shadow-sm">
              <div className="flex h-[200px] w-full items-center justify-center bg-secondary-100 px-4">
                {brand?.path ? (
                  <img src={brand.path} alt={brand?.label || 'Marca'} className="max-h-10 object-cover" />
                ) : (
                  <span className="text-center text-xl font-bold text-neutral-900">{brand?.label || 'Marca'}</span>
                )}
              </div>

              <button
                onClick={brand?.onClick}
                className="flex w-full items-center justify-start gap-2 border-0 bg-white px-4 py-4 text-sm font-semibold text-primary-800 transition-colors hover:underline">
                Conheça a marca <ArrowRightCircle size={16} />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Empty State */}
      {!isLoading && brandsList.length === 0 && (
        <div className="py-12 text-center">
          <Typography.Heading type="headingThree" className="mb-4 text-gray-900">
            Nenhuma marca encontrada
          </Typography.Heading>
          <Typography.Text className="text-gray-600">Não há marcas parceiras disponíveis no momento.</Typography.Text>
        </div>
      )}
    </div>
  )
}

export default Brands
